import { Actions, createEffect, ofType } from '@ngrx/effects';
import { AppState } from '@get/store/configs/reducers';
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { NewsletterApiService } from '@get/store/api-services';
import { GeneratedNewsletterEffects } from './newsletter-generated.effects';
import { NewsletterActions, NewsletterGeneratedActions, UserNewsletterGeneratedActions } from '@get/store/actions';
import { catchError, concatMap, map, of, switchMap } from 'rxjs';
import { Newsletter, UserNewsletter } from '@get/api-interfaces';

@Injectable()
export class NewsletterEffects extends GeneratedNewsletterEffects {
  constructor(actions$: Actions, newsletterApiService: NewsletterApiService, store$: Store<AppState>) {
    super(actions$, newsletterApiService, store$);
  }

  getManyNewslettersByOrganisation$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(NewsletterActions.getManyNewslettersByOrganisation),
      switchMap(({ params }) =>
        this.newsletterApiService.getNewslettersByOrganisation(params).pipe(
          map((newsletters: Newsletter[]) => {
            return NewsletterGeneratedActions.normalizeManyNewslettersAfterUpsert({ newsletters });
          }),
          catchError(error => of(NewsletterGeneratedActions.newslettersFailure({ error })))
        )
      )
    );
  });

  getNewslettersUnread$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(NewsletterActions.getNewslettersUnread),
      switchMap(({ params }) =>
        this.newsletterApiService.getNewslettersUnread(params).pipe(
          map((newsletters: Newsletter[]) => {
            return NewsletterGeneratedActions.normalizeManyNewslettersAfterUpsert({ newsletters });
          }),
          catchError(error => of(NewsletterGeneratedActions.newslettersFailure({ error })))
        )
      )
    );
  });

  markAsRead$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(NewsletterActions.markAsRead),
      concatMap(({ idsNewsletter }: { idsNewsletter: number[] }) => {
        return this.newsletterApiService.markAsRead(idsNewsletter).pipe(
          map((userNewsletterReturned: UserNewsletter[]) => {
            return UserNewsletterGeneratedActions.normalizeManyUserNewslettersAfterUpsert({
              userNewsletters: userNewsletterReturned
            });
          }),
          catchError(error => of(NewsletterGeneratedActions.newslettersFailure({ error })))
        );
      })
    );
  });
}
